export const facturationComplete = 'COMPLETE';
export const facturationSimplifiee = 'SIMPLIFIEE';
export const facturationAgregee = 'AGREGEE';
export const facturationCompleteLibelle = 'Complète';
export const facturationSimplifieeLibelle = 'Simplifiée';
export const facturationAgregeeLibelle = 'Agrégée';

export const facturationCompleteDescription =
    'Facture contenant une ligne par article. (Libellés affichés)';
export const facturationSimplifieeDescription =
    'Facture contenant une ligne par taux de TVA. (Libellés non affichés)';
export const facturationAgregeeDescription =
    'Facture contenant une ligne par rubrique de facturation et taux de TVA. (Libellés non affichés)';

export type facturationType =
    | typeof facturationComplete
    | typeof facturationSimplifiee
    | typeof facturationAgregee;

export const paddingFacturationTab = '32px';
export const heightFooterFacturation = '140px';

export const infosSurFactureComplete = 'COMPLETE';
export const infosSurFactureAucune = 'AUCUNE';
export const infosSurFactureCompleteLibelle = 'Nom du client facturé et de la formalité';
export const infosSurFactureAucuneLibelle = 'Aucune';

export const infosSurFactureCompleteDescription =
    'Ligne supplémentaire pour le nom du client facturé et des formalités';
export const infosSurFactureAucuneDescription = 'Aucune ligne supplémentaire';

export type infosSurFactureType = typeof infosSurFactureComplete | typeof infosSurFactureAucune;

export const fPascontactfactureTrue = true;
export const fPascontactfactureFalse = false;
export const fPascontactfactureTrueLibelle = 'Masquer le contact';
export const fPascontactfactureFalseLibelle = 'Garder le contact';

export const fPascontactfactureTrueDescription = 'Masquer le contact sur la facture';
export const fPascontactfactureFalseDescription = 'Masquer le contact sur la facture';
